import React from 'react'
import { GatsbyImage, withArtDirection } from 'gatsby-plugin-image'
import { css } from '@emotion/react'

/** @param {{ pcImageData: any, spImageData?: any, alt: string, breakPoint?: number, className?: string, loading?: 'eager' | 'lazy', sizes?: string }} props */
const ResponsiveGatsbyImage = ({ pcImageData, spImageData, alt, breakPoint = 424, className, loading = 'lazy', sizes }) => {
  const imageData = spImageData
    ? withArtDirection(pcImageData, [
        {
          media: `(max-width: ${breakPoint}px)`,
          image: spImageData,
        },
      ])
    : pcImageData

  const spImageAspectRatio = spImageData ? `${spImageData.width} / ${spImageData.height} !important` : `${pcImageData.width} / ${pcImageData.height}`
  const spImagePaddingTopRatio = spImageData ? `${(spImageData.height / spImageData.width) * 100}% !important` : `${(pcImageData.height / pcImageData.width) * 100}%`
  // TODO: gatsby-plugin-imageをアップデート時に出力されるDOMの構造が変わる場合は再度調整必要(padding-topでの調整もしておく)
  const responsiveStyle = css`
    @media (max-width: ${breakPoint}px) {
      aspect-ratio: ${spImageAspectRatio};
      > div[aria-hidden='true'][style^='padding-top'] {
        padding-top: ${spImagePaddingTopRatio};
      }
    }
  `
  return <GatsbyImage image={imageData} alt={alt} className={className} css={responsiveStyle} loading={loading} sizes={sizes} />
}

export default ResponsiveGatsbyImage
